import { NeedsAnalysisValue } from './../enums/needs-analysis.enum';

export interface IFNAValues {
  premium_vs_core_cover: NeedsAnalysisValue;
  premium_vs_nice_to_haves: NeedsAnalysisValue;
  premium_vs_low_excess: NeedsAnalysisValue;
  core_cover_vs_nice_to_haves: NeedsAnalysisValue;
  core_cover_vs_low_excess: NeedsAnalysisValue;
  nice_to_haves_vs_low_excess: NeedsAnalysisValue;
}
export interface IPriorityRating {
  name: string;
  value: number;
  ranking_position: string;
}
export interface IPastFNA extends IFNAValues {
  analysis_date: number;
}
